var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, maxWidth: "900px" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading_save },
                  on: { click: _vm.save }
                },
                [_vm._v(" Salvar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Atualização diária" } }),
      _c(
        "div",
        [
          _c("div", [
            _c("p", [
              _vm._v(
                " Para melhorar a sua experiência, nós podemos atualizar automaticamente as suas contas de investimentos, diariamente, para você e seu profissional terem sempre acesso aos dados mais atuais. "
              )
            ]),
            _c("p", [
              _vm._v(
                " Conforme regulação, esse consentimento é fornecido pelo prazo de 12 meses. Após esse prazo, você pode renovar a permissão. "
              )
            ]),
            _c("p", [
              _vm._v(" Selecione as contas que deseja atualizar diariamente: ")
            ])
          ]),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.contas,
              loading: _vm.loading,
              height: "250",
              "fixed-header": "",
              "show-select": "",
              "disable-pagination": "",
              "hide-default-footer": "",
              "item-key": "id_conta"
            },
            scopedSlots: _vm._u([
              {
                key: "header.data-table-select",
                fn: function(props) {
                  return [
                    _c(
                      "v-simple-checkbox",
                      _vm._g(
                        {
                          attrs: {
                            indeterminate: props.props.indeterminate,
                            color: "primary",
                            disabled: _vm.loading_save
                          },
                          model: {
                            value: props.props.value,
                            callback: function($$v) {
                              _vm.$set(props.props, "value", $$v)
                            },
                            expression: "props.props.value"
                          }
                        },
                        props.on
                      )
                    )
                  ]
                }
              },
              {
                key: "item.data-table-select",
                fn: function(props) {
                  return [
                    _c("v-simple-checkbox", {
                      attrs: {
                        value: props.isSelected,
                        color: "primary",
                        disabled:
                          _vm.loading_save ||
                          _vm.contas_salvas.includes(props.item.id_conta)
                      },
                      on: {
                        input: function($event) {
                          return props.select($event)
                        }
                      }
                    })
                  ]
                }
              },
              {
                key: "item.conta_corretora",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.cpf ||
                              item.conta ||
                              item.conta_corretora ||
                              item.email ||
                              "-"
                          ) +
                          " "
                      )
                    ])
                  ]
                }
              },
              {
                key: "item.actions",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "div",
                      [
                        item.loading
                          ? _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                size: "18",
                                color: "primary"
                              }
                            })
                          : _vm._e(),
                        item.response
                          ? _c(
                              "div",
                              [
                                item.response.status === 200
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { left: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "success"
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-check-outline "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.response.message) +
                                              " "
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                item.response.status !== 200
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { left: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "red"
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-alert-circle-outline "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.response.message) +
                                              " "
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.contas_selecionadas,
              callback: function($$v) {
                _vm.contas_selecionadas = $$v
              },
              expression: "contas_selecionadas"
            }
          }),
          _c("v-checkbox", {
            attrs: {
              label: "Não mostrar novamente este aviso.",
              disabled: _vm.loading_save
            },
            model: {
              value: _vm.nao_mostrar,
              callback: function($$v) {
                _vm.nao_mostrar = $$v
              },
              expression: "nao_mostrar"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }